import { render, staticRenderFns } from "./OutOfOffice.vue?vue&type=template&id=2225a3bd"
import script from "./OutOfOffice.vue?vue&type=script&lang=js"
export * from "./OutOfOffice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports